export const YES = true;
export const FORM_NAME = 'reactWidgets';
export const UNEMPLOYMENT = 'isUnemploymentSelected';
export const FORM_VALIDATION_ERROR_MESSAGE = new Array('Niet alle velden zijn (correct) ingevuld.');
export const residualPeriods = [
  { textField: '180 dagen', valueField: 'DAYS_180' },
  { textField: '365 dagen', valueField: 'DAYS_365' },
  { textField: '730 dagen', valueField: 'DAYS_730' },
];
export const allowanceTypes = [
  { textField: 'uitkering naar rato', valueField: 'PRO_RATA' },
  { textField: 'volledige uitkering', valueField: 'FULL' },
];
export const disabilityRates = [
  { textField: 'beroepsarbeid', valueField: 'OWN_LABOUR' },
  { textField: 'passende arbeid', valueField: 'FITTING_LABOUR' },
  { textField: 'gangbare arbeid', valueField: 'ACCEPTABLE_LABOUR' },
];
export const insurancePeriods = [
  { textField: '2 jaar', valueField: 'YEARS_2' },
  { textField: '5 jaar', valueField: 'YEARS_5' },
  { textField: '10 jaar', valueField: 'YEARS_10' },
  { textField: 'tot einddatum', valueField: 'INSURANCE_END_DATE' },
];
export const unemploymentPeriods = [
  { textField: '12 maanden', valueField: 'YEARS_1' },
  { textField: '24 maanden', valueField: 'YEARS_2' },
];
export const BIRTHDATE = 'dateOfBirthDay';
export const DISABILITY_VALUE = 'sumAssured';
export const UNEMPLOYMENT_VALUE = 'unemploymentSumAssured';
